<template>
  <BaseDialogForm :is-edit="false">
    <template v-slot:toggle="{ on }">
      <v-btn color="primary" v-on="on" @click.stop="onOpen()">
        <v-icon left>
          add_box
        </v-icon>
        New Raw Origin
      </v-btn>
    </template>
    <template v-slot:title>
      <h2>Make a New Origin</h2>
    </template>
    <template v-slot:content>
      <v-form v-model="$v.valid" @submit.prevent="submit">
        <v-autocomplete
          v-model="$v.formdata.rawmaterial_id.$model"
          :error-messages="rawmaterialErrors"
          :items="rawmaterials"
          :loading="loading"
          item-value="id"
          :item-text="item => item.barcode + ' ' + item.name"
          @input="$v.formdata.rawmaterial_id.$touch()"
          @blur="$v.formdata.rawmaterial_id.$touch()"
          label="Raw Material"
          prepend-icon="grain"
        />
        <v-text-field
          v-model="$v.formdata.quantity.$model"
          :error-messages="quantityErrors"
          type="number"
          label="Quantity"
          :suffix="formdata.units"
          counter="13"
          hint="How much material did you use?"
          :prepend-icon="formdata.quantityIcon"
          @input="$v.formdata.quantity.$touch()"
          @blur="$v.formdata.quantity.$touch()"
        />
        <v-select
          v-model="$v.formdata.units.$model"
          :error-messages="unitErrors"
          label="Units"
          :items="units"
          prepend-icon="fas fa-dumbbell"
          @input="$v.formdata.units.$touch()"
          @blur="$v.formdata.units.$touch()"
        />
      </v-form>
    </template>

    <template v-slot:actions="{ close }">
      <v-btn color="warning" dark @click="clear">
        <v-icon left>fas fa-redo</v-icon>
        Clear
      </v-btn>
      <v-btn
        :disabled="$v.$invalid"
        color="primary"
        @click="
          submit();
          close();
        "
      >
        <v-icon dark left>
          fas fa-save
        </v-icon>
        Save
      </v-btn>
    </template>
  </BaseDialogForm>
</template>

<script>
import RawMaterial from "../../models/RawMaterial";
import { validationMixin } from "vuelidate";
import { handleErrors } from "../../services/formErrors";
import BaseDialogForm from "../Base/BaseDialogForm";
import BatchRawOrigin from "../../models/BatchRawOrigin";
export default {
  name: "BatchRawOriginForm",
  components: {
    BaseDialogForm
  },
  mixins: [validationMixin],
  validations: BatchRawOrigin.validations,
  props: {
    instance: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    materialid: {
      type: Number,
      required: true
    },
    batchid: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      units: ["g", "kg", "mg", 'mL', 'L', "units"],
      formdata: new BatchRawOrigin(this.instance)
    };
  },
  computed: {
    // return error messages for validated fields
    quantityErrors() {
      return handleErrors("formdata", "quantity", this);
    },
    unitErrors() {
      return handleErrors("formdata", "units", this);
    },
    rawmaterialErrors() {
      return handleErrors("formdata", "rawmaterial_id", this);
    },
    // For raw material selection field
    rawmaterials() {
      return RawMaterial.query()
        .where("material_id", this.materialid)
        .where("archived", false)
        .get();
    }
  },
  methods: {
    onOpen() {
      RawMaterial
        .$fetchByMaterial(this.materialid)
        .then(() => (this.loading = false));
    },
    submit() {
      this.$v.$touch();
      this.formdata.batch_id = this.batchid;
      BatchRawOrigin
          .$post(this.formdata.toCreatePayload())
          .then(() => this.clear())
    },
    clear() {
      this.formdata = new BatchRawOrigin();
      this.$v.$reset();
    }
  }
}
</script>
